// Écran de connexion.
// Mise en page reprise du site : moitié gauche en dégradé bleu marine
// vers bleu nuit, moitié droite blanche avec le formulaire.

import { useState } from 'react';
import { TextField } from '../../ui/TextField.jsx';
import Button from '../../ui/Button.jsx';
import { useSession } from '../../lib/session.jsx';
import logoNeg from '@branding/logo-mertens-neg.png';
import './login.css';

export function LoginPage() {
  const { login } = useSession();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(event) {
    event.preventDefault();
    setPending(true);
    setError(null);
    try {
      await login(username, password);
    } catch (err) {
      // Le message vient de l'API et reste volontairement générique :
      // « Identifiants incorrects » pour un compte inexistant comme
      // pour un mot de passe faux — on ne laisse pas énumérer les
      // comptes existants.
      setError(err.message ?? 'Connexion impossible.');
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="login">
      <aside className="login__brand">
        <div className="login__brand-inner">
          {/* Négatif sur le dégradé bleu marine. */}
          <img className="login__logo" src={logoNeg} alt="Mertens Mécanique" />
          <p className="login__brand-text">
            Chiffrage de pièces usinées. Le prix est calculé par le programme, à partir de
            vos taux et de votre gamme — jamais estimé.
          </p>
        </div>
      </aside>

      <main className="login__panel">
        <form className="login__form stack" onSubmit={onSubmit}>
          <div className="stack stack--tight">
            <h1>Connexion</h1>
            <p className="login__hint">Identifiez-vous pour accéder aux devis.</p>
          </div>

          <TextField
            label="Identifiant"
            name="username"
            autoComplete="username"
            required
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <TextField
            label="Mot de passe"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error ? (
            <p className="login__error" role="alert">
              {error}
            </p>
          ) : null}

          <Button type="submit" variant="primary" block disabled={pending}>
            {pending ? 'Connexion…' : 'Se connecter'}
          </Button>
        </form>
      </main>
    </div>
  );
}

export default LoginPage;
